import { Grid } from "@chakra-ui/react";
import styled from "styled-components";


export const StyledGrid = styled(Grid) `

  @media screen and (max-width: 1040px) {
    overflow-x: scroll;
  }

`

export const StyledGrid2 = styled(Grid) `

  @media screen and (max-width: 700px) {
    overflow-x: scroll;
  }

`